// extracted by mini-css-extract-plugin
module.exports = {"student-type-block":"student-type-selector_student-type-block__Xq7hG","student-type-dropdown":"student-type-selector_student-type-dropdown__BhvUF"};